/* unplugin-vue-components disabled */import script from "./SpaceHitCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SpaceHitCard.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__